import type { Language } from "../../contexts/LanguageContext";

export const employeesLabels: Record<Language, {
  page: {
    title: string;
    new: string;
    loading: string;
    empty: string;
    back: string;
    invalidId: string;
    table: { name: string; color: string; email: string; role: string; actions: string };
    roles: { admin: string; user: string };
    editTitle: string;
    buttons: { cancel: string; save: string; remove: string; keep: string };
    confirmSelfDemote: { title: string; description: string };
  };
  newModal: {
    title: string;
    fields: { 
      name: string; 
      namePlaceholder: string;
      email: string; 
      emailPlaceholder: string;
      password: string; 
      passwordPlaceholder: string;
      color: string; 
      capacity: string; 
      admin: string;
    };
    buttons: { cancel: string; add: string };
    toasts: {
      fillRequired: string;
      error: string;
      success: string;
    };
  };
}> = {
  pt: {
    page: {
      title: "Profissionais",
      new: "Novo profissional",
      loading: "Carregando...",
      empty: "Nenhum profissional.",
      back: "Voltar",
      invalidId: "ID inválido.",
      table: { name: "Nome", color: "Cor", email: "Email", role: "Perfil", actions: "Ações" },
      roles: { admin: "Administrador", user: "Usuário" },
      editTitle: "Editar profissional",
      buttons: { cancel: "Cancelar", save: "Salvar", remove: "Remover", keep: "Manter" },
      confirmSelfDemote: {
        title: "Remover acesso de administrador?",
        description: "Tem certeza que deseja remover seu próprio acesso de administrador?",
      },
    },
    newModal: {
      title: "Novo funcionário",
      fields: {
        name: "Nome",
        namePlaceholder: "Nome completo",
        email: "Email",
        emailPlaceholder: "email@exemplo.com",
        password: "Senha",
        passwordPlaceholder: "••••••••",
        color: "Cor do funcionário",
        capacity: "Atendimentos simultâneos",
        admin: "Administrador",
      },
      buttons: { cancel: "Cancelar", add: "Adicionar" },
      toasts: {
        fillRequired: "Preencha todos os campos obrigatórios",
        error: "Erro ao criar profissional",
        success: "Profissional criado com sucesso!",
      },
    },
  },
  en: {
    page: {
      title: "Professionals",
      new: "New professional",
      loading: "Loading...",
      empty: "No professionals.",
      back: "Back",
      invalidId: "Invalid ID.",
      table: { name: "Name", color: "Color", email: "Email", role: "Role", actions: "Actions" },
      roles: { admin: "Admin", user: "User" },
      editTitle: "Edit professional",
      buttons: { cancel: "Cancel", save: "Save", remove: "Remove", keep: "Keep" },
      confirmSelfDemote: {
        title: "Remove admin access?",
        description: "Are you sure you want to remove your own admin access?",
      },
    },
    newModal: {
      title: "New employee",
      fields: {
        name: "Name",
        namePlaceholder: "Full name",
        email: "Email",
        emailPlaceholder: "email@example.com",
        password: "Password",
        passwordPlaceholder: "••••••••",
        color: "Employee color",
        capacity: "Simultaneous appointments",
        admin: "Administrator",
      },
      buttons: { cancel: "Cancel", add: "Add" },
      toasts: {
        fillRequired: "Fill all required fields",
        error: "Error creating professional",
        success: "Professional created successfully!",
      },
    },
  },
};

